import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function TargetSection() {
  return <section className="py-20 px-4 bg-cream-100" data-id="element-116">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-sage" data-id="element-118">
          <h3 className="text-2xl font-bold text-brown mb-6" data-id="element-119">
            Esto es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-120">
            {['Te inflas en la tarde o amaneces inflamada', 'Quieres algo simple y corto', 'No quieres vivir a dieta', "Necesitas opciones 'de trabajo/para llevar'"].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-121">
                <div className="mt-1 bg-sage/20 p-1 rounded-full text-sage-dark" data-id="element-122">
                  <Check size={16} data-id="element-123" />
                </div>
                <span className="text-brown-light" data-id="element-124">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-terracotta" data-id="element-125">
          <h3 className="text-2xl font-bold text-brown mb-6" data-id="element-126">
            No es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-127">
            {['Buscas pérdida de peso rápida', 'Tienes síntomas fuertes o persistentes (ahí toca médico)', 'No quieres registrar nada (el tracker es parte del método)'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-128">
                <div className="mt-1 bg-terracotta/10 p-1 rounded-full text-terracotta" data-id="element-129">
                  <X size={16} data-id="element-130" />
                </div>
                <span className="text-brown-light" data-id="element-131">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}